import React from 'react';
import { TabsOption } from 'global';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import { useViewTypeContext } from 'contexts/contentViewType';
import { ClosedLostPerformance } from 'modules/finance/closedLost';
import { PipelineAndWonPerformance } from 'modules/finance/pipelineAndWon';
import { SharedFinanceFilters } from 'modules/finance/sharedFilters';

interface Props {
  sharedFilters: SharedFinanceFilters;
  onSharedFiltersChange: (filters: SharedFinanceFilters) => void;
}

type PerformanceSubTab = 'pipeline-and-won' | 'closed-lost';

export const FinancePerformancePage = ({ sharedFilters, onSharedFiltersChange }: Props) => {
  const { contentViewType } = useViewTypeContext();

  const tabs: TabsOption<PerformanceSubTab>[] = [
    {
      value: 'pipeline-and-won',
      label: 'Pipeline + Won',
      component: (
        <PipelineAndWonPerformance sharedFilters={sharedFilters} onSharedFiltersChange={onSharedFiltersChange} />
      ),
    },
    {
      value: 'closed-lost',
      label: 'Closed Lost',
      component: <ClosedLostPerformance sharedFilters={sharedFilters} onSharedFiltersChange={onSharedFiltersChange} />,
    },
  ];

  return (
    <TabsContainer<PerformanceSubTab>
      tabs={tabs}
      tabsWrapperProps={{ px: 2, pt: 1 }}
      contentViewType={contentViewType}
    />
  );
};
